
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { StoreService } from '../_services/store.service';

import { NotificationService } from '../_services/notification.service';


@Injectable()
export class StoreGuard implements CanActivate {
    constructor(
        private router: Router,
        private _storeService: StoreService,
        private _notificationService: NotificationService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (this._storeService.hasSelectedStore()) {
            return true;
        } else {
            this.router.navigate(['/super/select-store']);
            this._notificationService.notify(
                'danger',
                'Select Store',
                'Please Select a store',
                'top',
                'right');
            return false;
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/_guards/store.guard.ts